<template>
<div class="cd-section" id="features" >      
        <!--     *********     FEATURES 3      *********      -->
        <div class="features-3">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 ml-auto mr-auto">
                        <h2 class="title">이용약관</h2>
                        <h4>집비오 및 제반 서비스 이용과 관련하여 필요한 사항을 규정합니다.</h4>
                        <!--1조-->
                        <h4 class="info-title jipvio-text-left">제1조 (목적)</h4>
                        <h5 class="description jipvio-text-left">
                        본 약관은 집비오부동산중개 (이하 “회사”라 함)이 “집비오” 브랜드를 사용하여 구현되는 회사가 운영하는 플랫폼(이하 “집비오 플랫폼”이라 함)을 통해 제공하는 일체의 서비스(이하 “서비스”라 함)의 이용과 관련하여 회사와 이용자 사이의 회사와 회원과의 권리, 의무 및 책임사항, 법률관계 및 기타 필요한 사항을 규정함을 목적으로 합니다. 집비오 서비스라 함은 회사가 제공하는 “집비오” 브랜드를 사용하는 서비스를 말합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
                        </h5>
                        <!--2조-->
                        <h4 class="info-title jipvio-text-left">제2조 (정의)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
                        <ol class="pl-30">
                            <li>
                            “회원”이라 함은 회사의 "서비스"에 접속하여 이 약관에 따라 “회사”에 개인정보를 제공하여 회원등록을 하고, "회사"가 제공하는 "서비스"를 이용하는 고객을 말합니다.   
                            </li>
                            <li>
                                “비회원”이라 함은 회원등록 없이 서비스를 이용하는 자로서, “회사” 제공하는 일부 서비스 이용에 제한을 받을 수 있습니다.
                            </li>
                            <li>
                               “이용자”라 함은 집비오 플랫폼을 통해 “회사”가 제공하는 각종 서비스를 이용하는 자로서 “회원” 및 “비회원”을 포함합니다. 
                            </li>
                            <li>
                                “콘텐츠공급자”라 함은 서비스에 게재될 수 있도록 “회사”에 각종 정보 및 콘텐츠 등 내용물 일체를 제공하는 주체로서 사람이나 기관을 의미합니다. 대표적으로 이용자 등이 있습니다.
                            </li>
                            <li>
                                “자료” 혹은 “콘텐츠”라 함은 콘텐츠공급자가 제공한 각종 정보, 콘텐츠로써 서비스 상에 게시된 부호, 문자, 음성, 음향, 화상, 동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일, 링크, 다운로드, 광고 등을 포함하여 본 서비스에 게시물 형태로 포함되어 있거나, 본 서비스를 통해 배포, 전송되거나, 본 서비스로부터 접근되는 정보를 의미합니다.
                            </li>
                            <li>
                            “아이디(ID)”라 함은 “회원”의 식별과 서비스 이용을 위하여 “회원”이 설정하고 “회사”가 승인한 “회원” 본인의 문자와 숫자의 조합을 의미하며 “회원”이 설정한 이메일 주소 등이 포함됩니다.  
                            </li>
                            <li>
                            “비밀번호”라 함은 “회원”의 동일성 확인과 회원정보의 보호를 위하여 “회원”이 설정하고 “회사”가 승인한 문자나 숫자의 조합을 말합니다.
                            </li>
                            <li>
                            “유료서비스”라 함은 집비오 서비스를 통해 유료로 이용 가능한 “회사” 또는 “링크사용자” 등 “회사”와 계약을 체결한 제3자가 제공하는 각종 온라인 디지털 콘텐츠 및 제반 서비스를 말합니다. 정보 및 광고 게시 서비스 등이 포함됩니다.
                            </li>
                            <li>
                            “탈퇴”라 함은 “회원”이 이용계약을 종료 시키는 행위를 뜻합니다.
                            </li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② 이 약관에서 사용하는 용어 중 본 조에서 정하지 아니한 것은 관계법령 및 일반관례에 따릅니다.
                        </h5>
                        <!--3조-->
                        <h4 class="info-title jipvio-text-left">제3조 (약관 등의 명시와 설명 및 개정)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호․모사전송번호․전자우편주소, 사업자등록번호, 중개업소 등록번호, 통신판매업 신고번호, 개인정보관리책임자등을 이용자가 쉽게 알 수 있도록 "회원"이 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 "약관의규제에관한법률", "정보통신망이용촉진및정보보호에관한법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.
                        </h5>
                        <!--4조-->
                         <h4 class="info-title jipvio-text-left">제4조 (약관의 해석)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 개별 서비스에 대해서는 별도의 이용약관 및 정책("기타 약관 등"이라 함)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "기타 약관 등"이 우선하여 적용됩니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 "기타 약관 등" 및 관계법령 또는 상관례에 따릅니다.
                        </h5>
                        <!--5조-->
                        <h4 class="info-title jipvio-text-left">제5조 (운영정책의 적용)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 본 약관에 따라 "회사”의 서비스를 이용하는 이용자의 유형은 서비스 이용 목적 및 방식에 따라 아래와 같이 분류되며, 경우에 따라 특정 이용자가 두개 이상의 유형에 중복 해당할 수 있습니다. 단, 본 항의 유형은 향후 서비스의 추가, 변경 및 삭제에 따라 수시로 변동될 수 있습니다.
                        <ol class="pl-30">
                        <li>임대인 : 본인 소유의 주거용 건축물을 집비오 플랫폼을 통해 임대차를 의뢰하는 자</li>
                        <li>일반사용자: 집비오 플랫폼을 통해 회사 또는 제3자로부터 각종 서비스를 제공받아 이용하는 자</li>
                        <li>공인중개사 : 집비오 플랫폼을 통해 부동산 관련 정보 및 광고 게시 서비스를 이용하는 자</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② “회사”는 서비스운영을 위해 별도의 운영정책을 마련하여 운영할 수 있으며, “회사”는 서비스에 운영정책을 사전 공지 후 적용합니다. 운영정책의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있으며, 본 약관에 동의한 이용자 모두에게 그 효력이 발생합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ 본 약관에서 규정되지 않은 사항이나 해석에 대해서는 별도의 운영정책, 관련법령 또는 상관례에 따릅니다. 또한 본 약관과 운영정책이 내용상 충돌할 경우 별도 규정된 운영정책상의 내용이 효력상 우선합니다.
                        </h5>
                        <!--6조-->
                        <h4 class="info-title jipvio-text-left">제6조 (회원가입 및 회원 정보의 변경)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 회원가입 계약은 회원이 되고자 하는 자(이하 “가입신청자”라 함)가 약관의 내용에 동의를 한 다음 회사가 정한 절차에 따라 가입신청을 하고, 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다. 회원가입 계약의 성립시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② “회사”는 다음 각 호에 해당하는 가입신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
                        <ol class="pl-30">
                        <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우. 단, 회사의 회원 재가입 승낙을 얻은 경우에는 예외로 함.</li>
                        <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
                        <li>허위의 정보를 기재하거나 회사가 제시하는 내용을 기재하지 않은 경우</li>
                        <li>가입신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ 제 1 항에 따른 신청에 있어 “회사”는 가입신청자에게 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④ "회원"은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편주소 또는 기타 방법으로 "회사"에 그 변경사항을 알려야 합니다. 변경사항을 “회사”에 알리지 않아 발생한 불이익에 대하여 “회사”는 책임지지 않습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑤ 회원가입은 반드시 본인의 진정한 정보를 통하여만 가입할 수 있으며 “회사”는 “회원”이 등록한 정보에 대하여 확인조치를 할 수 있습니다. “회사”는 회원 정보의 사실 여부 등에 대한 확인이 완료될 때까지 집비오 서비스의 제공을 중단할 수 있고, 타인의 정보를 임의로 사용함으로써 발생하는 회사, 실제 해당 정보의 소유자, 콘텐츠공급자 등의 손실과 손해에 대한 책임은 “회원”에게 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑥ “회사”는 서비스의 원활한 제공을 위해 “회원”의 등급을 회사 내부의 정책에 따라 세분하여 이용에 차등을 둘 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑦ “회원”은 서비스 이용 신청 등 요청할 당시 기재한 사항이 변경되었을 경우에는 즉시 변경사항을 최신의 정보로 수정하여야 합니다. 다만, “회사”가 정한 정보 항목은 “회사”의 승인을 받아 수정할 수 있습니다. 수정하지 않은 정보로 인하여 발생하는 손해는 당해 “회원”이 부담하고, “회사”는 이에 대하여 귀책사유가 없으면 책임을 지지 않습니다.
                        </h5>
                        <!--7조-->
                        <h4 class="info-title jipvio-text-left">제7조 (회원의 아이디 및 비밀번호에 대한 의무)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 아이디와 비밀번호에 관한 관리책임은 “회원”에게 있습니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ②   “회원”은 자신의 아이디 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③   “회원”이 자신의 아이디 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 “회사”에 통보하고 회사의 안내가 있는 경우에는 그에 따라야 합니다. “회원”의 계정 관리소홀, 부정사용 등에 의하여 발생하는 모든 책임과 불이익은 “회원”이 부담하여야 합니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④   “이용자”는 집비오 서비스를 이용하기 전에 서비스 이용약관을 확인하여야 합니다. 집비오 서비스 이용약관을 확인하지 않고 서비스를 이용하여 발생한 손실, 손해에 대한 책임은 “이용자“ 본인이 부담하여야 합니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                       ⑤  “이용자”는 본 약관 및 회사가 서비스와 관련하여 통지 또는 고지하는 내용과 관련법령 등을 준수하여야 하며, 본 약관 및 통지 또는 고지 내용이나 관련법령을 위반하거나 이행하지 아니하여 발생하는 손실, 손해에 대한 책임은 “이용자” 본인이 부담하여야 합니다. “회사”는 필요한 경우 “이용자”의 관련법령 등의 위반사실을 정부기관 또는 사법기관에 통지할 수 있습니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑥   집비오 서비스와 관련하여 “이용자”가 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 “이용자”가 부담하여야 합니다. 
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑦   이용자는 회사가 서비스를 안전하게 제공할 수 있도록 협조하여야 하며, 회사가 이용자의 본 약관 위반 등 부적절한 행위를 발견하여 이용자에게 해당 행위에 대하여 소명을 요청할 경우 이용자는 회사의 요청에 적극 응하여야 합니다. 
                        </h5>
                        <!--8조-->
                        <h4 class="info-title jipvio-text-left">제8조 ("회원"에 대한 통지)</h4>
                        <h5 class="description jipvio-text-left">
                       ①  "회사"가 "회원"에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한 "회원"이 지정한 (휴대)전화번호, 서비스 로그인 시 알림창, 전자우편주소, 서비스 내 전자메모 및 쪽지 등 합리적으로 가능한 수단으로 할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 "회원" 전체에 대한 통지의 경우 7일 이상 "회사"의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
                        </h5>
                        <!--9조-->
                        <h4 class="info-title jipvio-text-left">제9조 ("회사"의 의무)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로  "서비스"를 제공하기 위하여 최선을 다하여 노력합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 "회원"이 안전하게 "서비스"를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보보호정책을 공시하고 준수합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ "회사"는 서비스이용과 관련하여 "회원"으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 "회원"에게 처리과정 및 결과를 전달합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④ "회사"는 다음의 사항을 해당 " 유료서비스"의 이용초기화면이나 그 포장, FAQ 등에 "회원"이 알기 쉽게 표시합니다.
                        <ol class="pl-30">
                        <li>유료서비스의 명칭 또는 제호</li>
                        <li>유료서비스의 내용, 이용방법, 이용료, 결제방법 기타 이용조건</li>
                        <li>이용가능 기기 및 이용에 필요한 최소한의 기술사양</li>
                        </ol>
                        </h5>
                         <!--10조-->
                         <h4 class="info-title jipvio-text-left">제10조 (개인정보보호 의무)</h4>
                         <h5 class="description jipvio-text-left">
                         "회원이" "회사"의 "서비스"에 제공하는 정보 일체는 개인정보처리방침에 따르며, "회사"가 귀하의 정보를 수집 및 이용하는 행위는 동 정책에 따라 규율됩니다. "회원"은 본 서비스를 이용함으로써 "회사"가 "회원"의 정보를 수집 및 이용(개인정보처리방침에서 규정하는 바와 같음)하는 것에 동의하는 것으로 간주된다는 사실을 인지하고 있습니다. "회원"에게 본 서비스를 제공하는 것의 일환으로, "회사"는 서비스 관련 공지사항 및 행정적 사안에 관한 메시지를 비롯한 전달사항을 제공할 필요가 있을 수 있습니다.
                        </h5>
                        <!--11조-->
                        <h4 class="info-title jipvio-text-left">제11조 (서비스 이용의 중지 또는 계약의 해지)</h4>
                        <h5 class="description jipvio-text-left">
                        ①  "회원"은 다음 행위를 하여서는 안 됩니다.
                        <ol class="pl-30">
                        <li>신청 또는 변경 시 허위내용의 등록</li>
                        <li>타인의 정보도용</li>
                        <li>"회사"에 게시된 정보의 변경</li>
                        <li>"회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                        <li>"회사"와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                        <li>"회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                        <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 "회사"에 공개 또는 게시하는 행위</li>
                        <li>검색엔진 스팸, 도어웨어 페이지, 타 서비스와 매우 유사한 페이지 등 내용이 현저히 저급하거나 빈약하고 사용자에게 뚜렷한 부가 가치를 제공하지 않는 행위</li>
                        <li>“회사”에서 별도 규정한 콘텐츠 원칙에 어긋나거나, 성격에 부합하지 않는 행위</li>
                        <li>기타 불법적이거나 부당한 행위</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회원"은 관계법, 본 약관의 규정, 이용안내 및 "서비스"와 관련하여 공지한 주의사항, "회사"가 통지하는 사항 등을 준수하여야 하며, 기타 "회사"의 업무에 방해되는 행위를 하여서는 안 됩니다.
                        </h5>
                        <!--12조-->
                        <h4 class="info-title jipvio-text-left">제12조 (서비스의 제공 등)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② “이용자”는 “회사”가 제공한 서비스를 이용할 수 있습니다. 단 회원가입 등 회사가 정한 절차를 진행하지 않은 이용자의 경우 서비스의 이용이 일부 제한될 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ 회사가 제공하는 서비스는 다음과 같습니다.
                        <ol class="pl-30">
                        <li>이용자 거주 부동산 관련 정보 제공 및 편의 제공 등 생활정보 서비스, 매매, 임대, 분양, 부동산 시세, 지역정보, 통계, 금융 등 부동산과 관련한 서비스 및 기타 회사가 “집비오 플랫폼”을 통해 제공하는 각종 서비스</li>
                        <li>vr, 열화상이미지, 영상 등 다양한 qkdqjq을 통해 부동산 매물 정보를 제공하는 서비스</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                            ④ “회사”는 회원이 등록한 매물정보에 대해 등록 후 최대 7일 이내에 진위 여부를 확인하며, 진위 여 부 확인 즉시 해당 매물을 노출합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑤"회원"이 등록한 정보가 실제 정보와 불일치 하는 경우 "회사"는 "회원"이 가입시 제공한 전화번호 또는 이메일 을 통해 "회원"에게 매물정보의 수정을 요청합니다. "회사"가 "회원"이 제공한 연락수단으로 2회 이상 연락하 였음에도 불구하고 연락이 되지 않을 경우의 책임은 "회원"에게 있습니다.    
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑥전항에 따른 "회사"의 정당한 정보 수정 요청에도 불구하고 "회원"이 24시간 이내에 정보(거래완료 혹은 노출 종료와 같은 매물상태 변경 포함)를 수정하지 않을 경우, 회사는 해당 매물 및 공유사무실 정보의 노출을 중지 하고 "회원"의 서비스 이용을 제한 할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑦"회사"는 "집비오 플랫폼"에 등록된 매물 및 공유사무실 중 사회통념, 관례 및 회사의 합리적인 판단에 의하여 거래가 부적합하다고 판단되는 경우 이의 삭제를 요청하거나 직권으로 삭제할 수 있으며 해당 회원의 서비스 이용을 정 지 혹은 탈퇴시킬 수 있습니다. "집비오 플랫폼"에 거래부적합 부동산 매물 및 공유사무실을 등록할 경우, 거래부적합 매물에 대한 법적인 책임은 해당 등록자에게 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑧"회사"는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 "회사"는 제9조("회원"에 대한 통지)에 정한 방법으로 "회원"에게 통지합니다. 다만, "회사"가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑨"회사"는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공시한 바에 따릅니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑩사업종목의 전환, 사업의 포기 등의 이유로 "유료서비스"를 제공할 수 없게 되는 경우에는 "회사"는 제8조(회원에 대한 통지)에서 정한 방법으로 "회원"에게 통지하고 당초 "회사"에서 제시한 조건에 따라 "회원"에게 보상합니다.
                        </h5>
                        <!--13조-->
                        <h4 class="info-title jipvio-text-left">제13조 (서비스의 변경)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 및 운영의 필요상 수정, 중단, 변경할 수 있으며, 이에 대하여 관련법에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ "유료서비스"의 변경 내용이 중대하거나 "회원"에게 불리한 경우에는 "회사"가 해당 "유료서비스"를 제공받는 "회원"에게 제8조(회원에 대한 통지)에서 정한 방법으로 "회원"에게 통지합니다. 이때, "회사"는 동의를 거절한 "회원"에 대해서는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 계약을 중단할 수 있으며 이 경우 환불은 제19조에 따라 진행됩니다.
                        </h5>
                        <!--14조-->
                        <h4 class="info-title jipvio-text-left">제14조 (정보의 제공 및 광고의 게재)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 "회원"이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 "회원"에게 제공할 수 있습니다. 다만, "회원"은 관련법에 따른 거래관련 정보, 고객센터 답변 등을 제외하고 언제든지 전자우편 등을 통하여 수신 거절을 할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② 제1항의 정보를 전화 및 모사전송기기에 의하여 전송하려고 하는 경우에는 "회원"의 사전 동의를 받아서 전송합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ 회사는 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 팝업에 대하여 회사가 지정하는 위치에 공지사항 및 광고 등을 게재할 수 있습니다.
                        </h5>
                        <!--15조-->
                        <h4 class="info-title jipvio-text-left">제15조 (게시물의 저작권)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회원"이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회원"이 "서비스" 내에 게시하는 "콘텐츠"는 검색결과 내지 "서비스" 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, "회원"은 언제든지 고객센터 또는 "서비스" 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ "회사"는 제2항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.
                        </h5>
                        <!--16조-->
                        <h4 class="info-title jipvio-text-left">제16조 (게시물의 관리)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회원"의 게시물이 "정보통신망법" 및 "저작권법"등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, "회사"와 "회원"은 관련법에 따라 조치를 취하여야 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.
                        </h5>
                        <!--17조-->
                        <h4 class="info-title jipvio-text-left">제17조 (권리의 귀속)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "서비스"에 대한 저작권 및 지적재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, "회원"은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.
                        </h5>
                        <!--18조-->
                        <h4 class="info-title jipvio-text-left">제18조 (위치기반서비스 제공)</h4>
                        <h5 class="description jipvio-text-left">
                        ①   “회사”는 “이용자”에게 유용한 서비스를 제공하기 위하여 서비스에 위치기반서비스를 포함시킬 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ②   “회사”의 위치기반서비스는 “이용자”의 단말기기의 위치정보를 수집하는 위치정보 사업자로부터 위치정보를 전달 받아 이용자에게 제공하는 서비스이며, 구체적으로는 다음과 같은 목적에 사용됩니다.
                        <ol class="pl-30">
                        <li>이용자의 현재 위치 또는 특정 위치에 대한 정보를 활용하여 생성한 정보를 제공</li>
                        <li>이용자의 위치를 이용한 광고성 정보 제공</li>
                        <li>이용자의 위치를 통계작성, 학술연구 또는 시장조사를 위하여 특정 개인을 알아볼 수 없는 형태로 가공하여 정보 제공</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③   “회사”는 위치정보의 보호 및 이용 등에 관한 법률의 규정에 따라 개인위치정보 및 위치정보 이용ㆍ제공사실 확인 데이터를 6개월 이상 보관합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④   “이용자”의 무선서비스 이용 시 발생하는 데이터 통신료는 별도이며, 이용자께서 가입한 각 이동통신사의 정책에 따릅니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑤   “회사”는 고객이 등록한 매물의 위치정보만을 고객에게 제공하며, 해당 위치정보를 다른 정보와 결합하여 개인위치정보로 이용하지 않습니다.
                        </h5>
                        <!--19조-->
                        <h4 class="info-title jipvio-text-left">제19조 ("회원"의 계약해제, 해지 등)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회원"은 언제든지 자기 정보 관리 메뉴를 통하여 서비스 탈퇴 신청을 할 수 있으며, "회사"는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회원"이 계약을 해지할 경우, 관련법 및 개인정보보호정책에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ "회원"이 계약을 해지하는 경우, 본인 계정에 등록된 모든 데이터 일체는 삭제됩니다.
                        </h5>
                        <!--20조-->
                        <h4 class="info-title jipvio-text-left">제20조 (환불)</h4>
                        <h5 class="description jipvio-text-left">
                        ①   “이용자”가 이용요금 환불을 회사에 요구할 경우 회사가 정하는 별도의 규정에 따라 환불이 필요하다고 판단된다면 회사의 규정에 따라 환불 관련 절차를 진행해야 합니다. 회사는 이용자의 요청에 따라 검토 후 환불에 필요한 조치를 신속하게 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 과오금이 발생한 경우 이용대금의 결제와 동일한 방법으로 과오금 전액을 환불하여야 하며 "회사"가 과오금에 대한 환불을 거부할 경우 "회사"는 정당하게 이용대금이 부과되었음을 입증할 책임을 집니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ “회사”는 결제와 동일한 방법으로 환불을 진행하며, 결제와 동일한 방법으로 환불이 불가능한 때는 이를 사전에 고지합니다. 다만, 수납확인이 필요한 결제수단의 경우에는 수납확인일로부터 3영업일 이내에 이를 환불하도록 합니다.
                        </h5>
                        <!--21조-->
                        <h4 class="info-title jipvio-text-left">제21조 (이용제한 등)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 "회원"이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 서비스 이용을 경고, 일시정지, 계약해지로 단계적으로 제한할 수 있습니다.]
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"는 전항에도 불구하고, "주민등록법"을 위반한 명의도용 및 결제도용, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 계약해지를 할 수 있습니다. 본 항에 따른 계약해지 시 서비스 이용을 통해 획득한 혜택 등도 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③ "회사"는 무료회원이 계속해서 3개월 이상 로그인하지 않는 경우, 회원정보의 보호 및 운영의 효율성을 위해 이용을 제한할 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④ “회사”는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 이용제한정책 등에서 정한 바에 의합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑤ 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 "회사"는 제8조["회원"에 대한 통지]에 따라 통지합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ⑥ "회원"은 본 조에 따른 이용제한 등에 대해 "회사"가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.
                        </h5>
                         <!--22조-->
                        <h4 class="info-title jipvio-text-left">제22조 (손해배상 등)</h4>
                        <h5 class="description jipvio-text-left">
                        ①   “회사”는 “이용자”가 서비스를 이용함에 있어 “회사”의 고의 또는 과실로 인해 손해가 발생한 경우에는 민법 등 관련 법령이 규율하는 범위 내에서 그 손해를 배상합니다. 다만, “회사”는 아래와 같은 손해에 대해서는 “회사”의 고의 또는 중대한 과실이 없는 한 책임을 부담하지 않습니다. 또한 “회사”는 법률상 허용되는 한도 내에서 간접 손해, 특별 손해, 결과적 손해, 징계적 손해, 및 징벌적 손해에 대한 책임을 부담하지 않습니다.
                        <ol class="pl-30">
                        <li>천재지변 또는 이에 준하는 불가항력의 상태에서 발생한 손해</li>
                        <li>이용자의 귀책사유로 서비스 이용에 장애가 발생한 경우</li>
                        <li>서비스에 접속 또는 이용과정에서 발생하는 개인적인 손해</li>
                        <li>제3자가 불법적으로 회사의 서버에 접속하거나 서버를 이용함으로써 발생하는 손해</li>
                        <li>제3자가 회사 서버에 대한 전송 또는 회사 서버로부터의 전송을 방해함으로써 발생하는 손해</li>
                        <li>제3자가 악성 프로그램을 전송 또는 유포함으로써 발생하는 손해</li>
                        <li>전송된 데이터의 생략, 누락, 파괴 등으로 발생한 손해, 명예훼손 등 제3자가 서비스를 이용하는 과정에서 발생된 손해</li>
                        <li>기타 회사의 고의 또는 과실이 없는 사유로 인해 발생한 손해</li>
                        </ol>
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ②   “회사”는 법령상 허용되는 한도 내에서 서비스와 관련하여 본 약관에 명시되지 않은 어떠한 구체적인 사항에 대한 약정이나 보증을 하지 않습니다. 또한, “회사”는 자료에 대한 사실의 신뢰도 및 정확성 등에 대해서는 보증을 하지 않으며, “회사”의 고의 또는 중대한 과실 없이 발생된 이용자의 손해에 대하여는 책임을 부담하지 않습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③   “이용자”가 약관 및 “회사”가 정한 운영정책 등을 위반하거나 관계 법령을 위반하여 “회사”에 손해가 발생한 경우에는 “회사”에 그 손해를 배상하여야 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ④   “회원”이 서비스를 이용함에 있어 행한 불법행위나 제3항의 위반행위로 인하여 회사가 당해 이용자 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 당해 이용자는 자신의 책임과 비용으로 회사를 면책시켜야 하고, 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.
                        </h5>
                         <!--23조-->
                        <h4 class="info-title jipvio-text-left">제23조 (책임의 한계)</h4>
                        <h5 class="description jipvio-text-left">
                        ① "회사"는 천재지변 또는 이에 준하는 불가항력으로 인하여 "서비스"를 제공할 수 없는 경우에는 "서비스" 제공에 관한 책임이 면제됩니다.
                        </h5>
                         <h5 class="description jipvio-text-left">
                        ② "회사"는 "회원" 의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
                        </h5>
                         <h5 class="description jipvio-text-left">
                        ③ "회사"는 "회원"이 "서비스"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.
                        </h5>
                         <h5 class="description jipvio-text-left">
                        ④ "회사"는 "회원" 간 또는 "회원"과 제3자 상호간에 "서비스"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.
                        </h5>
                         <h5 class="description jipvio-text-left">
                        ⑤ "회사"는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.
                        </h5>
                         <h5 class="description jipvio-text-left">
                        ⑥ “회사"는 "회원"이 "서비스"를 이용하여 기대하는 수익을 보장하지 않습니다. 또한 이와 관련된 손해는 배상하지 않습니다.
                        </h5>
                         <!--24조-->
                        <h4 class="info-title jipvio-text-left">제24조 (분쟁해결)</h4>
                        <h5 class="description jipvio-text-left">
                        ①   “회사”는 이용자 상호간 분쟁에서 발생하는 문제에 대해서 일체의 책임을 지지 않습니다. 이용자 상호간 분쟁은 당사자간에 직접 해결해야 합니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ②   “이용자” 상호간에 서비스 이용과 관련하여 발생한 분쟁에 대해 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시ㆍ도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다.
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ③   “이용자”는 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며, 분쟁해결에 대한 “이용자”의 불성실로 인하여 콘텐츠공급자 또는 “회사”에 손해가 발생한 경우 “이용자”는 해당 손해를 배상할 책임을 부담합니다.
                        </h5>
                        <!--25조-->
                        <h4 class="info-title jipvio-text-left">제25조 (준거법 및 재판관할)</h4>
                        <h5 class="description jipvio-text-left">
                        ① 회사"와 "회원" 간 제기된 소송은 대한민국법을 준거법으로 합니다
                        </h5>
                        <h5 class="description jipvio-text-left">
                        ② "회사"와 "회원"간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.
                        </h5>
                     </div>
                </div>
                <!--<div class="row">
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-success icon-circle">
                                <i class="now-ui-icons objects_globe"></i>
                            </div>
                            <h4 class="info-title">Asset Management</h4>
                            <p class="description">Cross-account dashboards provide sophisticated reporting for enterprise.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-info icon-circle">
                                <i class="now-ui-icons education_atom"></i>
                            </div>
                            <h4 class="info-title">Resource Utilization</h4>
                            <p class="description">CloudCheckr provides summary and detailed usage statistics for resources.</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="info info-hover">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons tech_watch-time"></i>
                            </div>
                            <h4 class="info-title">Self-Healing</h4>
                            <p class="description">CloudCheckr enables users to save money, time, and effort.</p>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
        <!--     *********    END FEATURES 3      *********      -->
           
    </div>
</template>

<script>
import FeaturesSection from '@/pages/sections/Features'
export default {
  name: "Terms",
  components: {
   FeaturesSection,
  },
  
  methods: {
 
  },
};
</script>

<style></style>
